<template>
    <div>
        <div :class="{ 'show': toggleModal }" class="modal fade">
            <div class="modal-dialog modal-lg modal-dialog-centered" :class="consentID ? 'modal-max' : ''">
                <div class="modal-content" :style="consentID ? { height: '95vh' } : {}">
                    <div class="modal-header border-bottom">
                        <h5 class="modal-title h4 text-capitalize">
                            {{ sTitle }}
                        </h5>
                        <button type="button" class="close" @click="toggleModal = false">
                            <span aria-hidden="true"><i class="fal fa-times"></i></span>
                        </button>
                    </div>
                    <div class="modal-body" style="height: 80%; max-height: 100vh">
                        <div class="form-group">
                            <label class="form-label">Form Name</label>
                            <input class="form-control" type="text" v-model="title" required>
                            <div v-if="titleError" class="error-validation">{{ titleError }}</div>
                        </div>

                        <h6 v-show="!consentID" class="text-dark fw-500">Consent Form (PDF File Only)</h6>
                        <vue-dropzone
                            v-show="!consentID"
                            ref="dropzoneAdd"
                            class="text-center"
                            id="dropLogo"
                            :options="dropOptionsAdd"
                            @vdropzone-file-added="dropzoneAdd">
                        </vue-dropzone>

                        <!-- <vue-dropzone
                            v-show="consentID"
                            ref="dropzoneEdit"
                            class="text-center"
                            id="dropLogo"
                            :options="dropOptionsEdit">
                        </vue-dropzone> -->

                        <div v-if="fileError" class="error-validation">{{ fileError }}</div>

                        <iframe
                            v-show="consentID"
                            :src="consentURL"
                            style="width: 100%; height: 85%">
                        </iframe>

                        <button v-show="consentID" type="button" class="btn btn-primary" @click="openForm"> Open </button>
                        <button v-show="consentID && canShareForm" type="button" class="btn btn-success ml-2" @click="shareForm"> Share </button>
                    </div>
                    <div class="modal-footer">
                        <div class="row w-100 no-gutters">
                            <div v-if="consentID" class="col-auto">
                                <button
                                    type="button"
                                    class="btn btn-danger waves-effect waves-themed mr-2"
                                    @click="showDeleteModal(consentID)">
                                    <i class="fal fa-trash"></i>
                                </button>
                            </div>

                            <div class="col">
                            </div>
                            <div class="col-auto">
                                <button
                                    type="button"
                                    class="btn btn-secondary waves-effect waves-themed"
                                    @click="toggleModal = false">
                                    {{ $t('button_link.cancel') }}
                                </button>
                                <button
                                    type="button"
                                    class="btn btn-primary waves-effect waves-themed ml-2"
                                    @click="submitForm"
                                    :disabled="saveable">
                                    Save
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <deleteModal ref="deleteModal" @performConfirmAction="deleteFile"></deleteModal>
    </div>
</template>
<script>
import DeleteModal from './../../Delete_Modal.vue'
import vueDropzone from "vue2-dropzone";
import { handleSessionExpired } from './../../../../assets/js/dashboard/dashboard'
export default {
    name: 'ConsentFormForm',
    props: {
        isEdit: Boolean
    },
    components: {
        vueDropzone,
        DeleteModal,
    },
    data() {
        return {
            toggleModal: false,
            sTitle: '',
            saveable: false,

            consentID: 0,
            title: "",
            file: "",
            consentURL: '',
            canShareForm: false,

            titleError: '',
            fileError: '',

            dzShow: false,
            dropOptionsAdd: {
                url: this.$api.API_IMAGE,
                maxFiles: 1,
                paramName: 'filename',
                headers: {
                    token: this.$util.getSessionToken()
                },
                autoProcessQueue: false,
                acceptedFiles: 'application/pdf',
                addRemoveLinks: true,
                clickable: true,
            },
            dropOptionsEdit: {
                url: this.$api.API_IMAGE,
                maxFiles: 1,
                paramName: 'filename',
                headers: {
                    token: this.$util.getSessionToken()
                },
                autoProcessQueue: false,
                acceptedFiles: 'application/pdf',
                addRemoveLinks: false,
                clickable: false,
            },
        }
    },
    methods: {
        showModal(data) {
            this.toggleModal = true

            if (data) {
                this.sTitle = data.title

                this.consentID = data.consentID
                this.title = data.title
                this.file = data.url
                // this.consentURL = data.url.replace('https://img.tunai.io', 'https://localhost:5001')
                this.consentURL = data.url.replace('https://img.tunai.io', 'https://mall.tunai.io')

                // this.$refs['dropzoneEdit'].removeAllFiles()
                // this.$refs['dropzoneEdit'].manuallyAddFile({ name: data.title + '.pdf', type: 'application/pdf' }, data.url)
                // this.$refs['dropzoneEdit'].disable()

                // let collection = document.getElementsByClassName("dz-size")
                // for(let element of collection) {
                //     element.setAttribute("style", "display: none")
                // }

                try {
                    let temp = {
                        title: this.sTitle,
                        url: this.consentURL,
                    }

                    if (this.$window.navigator.canShare !== null && this.$window.navigator.share !== null) {
                        if (this.$window.navigator.canShare(temp)) {
                            this.canShareForm = true
                        }
                    }
                } catch (e) {
                    console.log(e)
                }

                return
            }

            this.sTitle = 'Add Consent Form'

            this.consentID = ''
            this.title = ''
            this.file = ''

            this.$refs['dropzoneAdd'].removeAllFiles()

            let collection = document.getElementsByClassName("dz-size")
            for (let element of collection) {
                element.removeAttribute("style")
            }
        },
        closeModal(isError) {
            // if (!isError) {
            //     if (this.$refs.deleteModal.toggleModal) {
            //         this.$refs.deleteModal.toggleModal = false
            //     } else if (this.dzShow) {
            //         this.dzShow = false
            //     } else {
            //         this.$emit('onItemChange')
            //     }
            // }
            // this.$parent.$parent.isModalShow = false
        },

        onItemChange() {
            this.$emit('onItemChange')
        },

        submitForm() {
            this.titleError = ''
            this.fileError = ''

            if (!this.title) {
                this.titleError = 'Please input consent form title'
                return
            }

            if (this.consentID) {
                let $vm = this
                $vm.$axios({
                    method: 'post',
                    url: 'https://bebusiness.tunai.io/consent/' + this.consentID + '/update',
                    headers: { token: $vm.$session.get('token') },
                    data: { title: this.title }
                })
                    .then((response) => {
                        if (response.status == 200) {
                            this.toggleModal = false

                            var message = 'Successfully update consent form'
                            $vm.$parent.$parent.setModal($vm, false, true, message)

                            this.$emit('onItemChange')
                        }
                    })
                    .catch((err) => {
                        console.log(err)
                        var errData = err.response.data;
                        if (errData.error == $vm.$api.INVALID_TOKEN) {
                            handleSessionExpired();
                        }
                    })
                return
            }

            if (this.$refs['dropzoneAdd'].getQueuedFiles().length === 0) {
                this.fileError = 'Please select file to upload'
                return
            }

            const formData = new FormData();
            formData.append('filename', this.$refs['dropzoneAdd'].getQueuedFiles()[0]);
            formData.append('title', this.title);

            let $vm = this
            $vm.$axios({
                method: 'post',
                url: 'https://bebusiness.tunai.io/consent',
                headers: { token: $vm.$session.get('token') },
                data: formData
            })
                .then((response) => {
                    if (response.status == 200) {
                        this.toggleModal = false

                        this.sTitle = ''
                        this.title = ''
                        this.file = ''
                        this.$refs['dropzoneAdd'].removeAllFiles()

                        var message = 'Successfully add consent form'
                        $vm.$parent.$parent.setModal($vm, false, true, message)

                        this.$emit('onItemChange')
                    }
                })
                .catch((err) => {
                    console.log(err)
                    var errData = err.response.data;
                    if (errData.error == $vm.$api.INVALID_TOKEN) {
                        handleSessionExpired();
                    }
                })
        },

        showDeleteModal(consentID) {
            this.consentID = consentID
            var title = this.$i18n.t('header.delete_file')
            var message = this.$i18n.t('message.confirmation.delete_file')
            this.$refs.deleteModal.showModal(title, message)
        },
        deleteFile() {
            let $vm = this
            $vm.$axios({
                method: 'post',
                url: 'https://bebusiness.tunai.io/consent/' + this.consentID + '/delete',
                headers: { token: $vm.$session.get('token') },
            })
                .then((response) => {
                    if (response.status == 200) {
                        this.toggleModal = false

                        this.sTitle = ''
                        this.title = ''
                        this.file = ''
                        // this.$refs['dropzoneEdit'].removeAllFiles()

                        var message = 'Successfully delete consent form'
                        $vm.$parent.$parent.setModal($vm, false, true, message)

                        this.$emit('onItemChange')

                        this.$refs.deleteModal.toggleModal = false
                    }
                })
                .catch((err) => {
                    console.log(err)
                    var errData = err.response.data;
                    if (errData.error == $vm.$api.INVALID_TOKEN) {
                        handleSessionExpired();
                    }
                })
        },

        dropzoneAdd() {
            let collection = document.getElementsByClassName("dz-progress")
            for (let element of collection) {
                element.setAttribute("style", "display: none")
            }
        },

        openForm() {
            window.open(this.consentURL, '_blank')
        },
        shareForm() {
            try {
                let temp = {
                    title: this.sTitle,
                    url: this.consentURL,
                }

                this.$window.navigator.share(temp);
            } catch (e) {
                console.log(e)
            }
        },
    },
    async mounted() {
    }
}
</script>
<style scoped>
.error-validation {
    font-size: 0.6875rem;
    margin-top: 0.325rem;
    color: #fd3995;
}
</style>